import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/indofishoil.com/public_html/src/app/home/components/BackToTopButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/indofishoil.com/public_html/src/app/home/components/CaseStudies.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/indofishoil.com/public_html/src/app/home/components/FreeResources.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/indofishoil.com/public_html/src/app/home/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/indofishoil.com/public_html/src/app/home/components/IndustrialFeedBenefits.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/indofishoil.com/public_html/src/app/home/components/LogisticsCompliance.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/indofishoil.com/public_html/src/app/home/components/ProtocolLibraryCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/indofishoil.com/public_html/src/app/home/components/ServicesGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/indofishoil.com/public_html/src/app/home/components/TechnicalSpecifications.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/indofishoil.com/public_html/src/components/Header.tsx");
